<template>
  <div>
    <div class="super">
      <div class="holder">
        <nav class="navbar  navbar-expand-lg fixed-top nav-top d-none">
          <router-link to="dashboard/landlord">
            <a class="navLinks d-none d-md-block" href="#"
              ><div class="dashboard-icon">
                <img src="../assets/images/database.svg" alt="dashboard" />
              </div>
              <span class="b2d"> Back to Dashboard</span></a
            >
          </router-link>
          <a class="navLinks d-md-none" href="#"
            ><router-link style="color:black;" to="dashboard/landlord">
              Dashboard</router-link
            ></a
          >
          <div class="logo m-auto">
            <div class="logo-div">
              <div
                class="logo-blueDiv-main"
                :class="{ hide_blueBg: scrollPosition > 50 }"
              >
                <img src="../assets/images/logo-header.svg" alt="logo" />
              </div>
              <div class="shelta-img-div" @click="backtohome()">
                <img src="../assets/images/logo1.svg" alt="" />
              </div>
            </div>
          </div>
          <a class="navLinks d-none d-md-block" href="#"
            ><div class="dashboard-icon">
              <img src="../assets/images/white-settings.svg" alt="dashboard" />
            </div>
            <span class="b2d">Manage settings</span></a
          >
          <a class="navLinks d-md-none" href="#">Settings</a>
        </nav>
        <div class="container-fluid body-wrap">
          <div class="progress-bar2">
            <div class="step">
              <p class="d-none d-md-block">Property details</p>
              <p class="d-md-none">Details</p>
              <!-- <p class=".hidden-md-up">Details</p> -->
              <div class="bullet">
                <span>1</span>
              </div>
              <div class="check fa fa-check"></div>
            </div>

            <div class="step">
              <p class="d-none d-md-block">Property location & Pricing</p>
              <p class="d-md-none">Location</p>
              <div class="bullet">
                <span>2</span>
              </div>
              <div class="check fa fa-check"></div>
            </div>

            <div class="step">
              <p class="d-none d-md-block">Documents & Media</p>
              <p class="d-md-none">Media</p>
              <div class="bullet">
                <span>3</span>
              </div>
              <div class="check check fa fa-check"></div>
            </div>

            <div class="step">
              <p>Finish</p>
              <div class="bullet">
                <span>4</span>
              </div>
              <div class="check fa fa-check"></div>
            </div>
          </div>

          <div class="form-outter">
            <form>
              <div class="page slidepage">
                <div class="container-fluid property-holder">
                  <div class="property-details">
                    <div class="details-body">
                      <div class="col-md-8 details-header">
                        <div class="details-header-text">
                          <p>Property Details</p>
                        </div>
                      </div>

                      <div class="col-md-8 details-first-section">
                        <div class="container pb-3 pt-3">
                          <div class="rls col-md-8">
                          <div
                            class="col-auto my-1"
                            v-for="(business, index) in businessTypes"
                            :key="index"
                          >
                            <!-- <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1">
                              <label class="form-check-label" for="inlineRadio1">1</label>
                            </div> -->
                            <div class="custom-control custom-radio mr-sm-2">
                              <input
                                type="radio"
                                class="custom-control-input"
                                :id="business.id"
                                name="businessType"
                                v-bind:value="business.id"
                                v-model="businesstype"
                              />
                              <label
                                class="custom-control-label"
                                v-bind:for="business.id"
                                >{{ business.businesstype }}</label
                              >
                            </div>
                            <!-- {{businesstype}} -->
                          </div>
                          </div>
                          <div class="title-wrap">
                            <div class="form-group">
                              <label class="select-label" for="title"
                                >Title
                                <span class="required_asterix">*</span></label
                              >
                              <input
                                id="title"
                                maxlength="40"
                                class="form-control form-select"
                                type="text"
                                placeholder="Enter Property Title"
                                v-model="title"
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <!-- <p>{{ type }}</p> -->
                                  <label class="select-label" for="type"
                                    >Property Type
                                    <span class="required_asterix"
                                      >*</span
                                    ></label
                                  >
                                  <select
                                    @change="getSubTypeInfo()"
                                    v-model="type"
                                    id="type"
                                    class="form-control form-select"
                                    name="type"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option
                                      v-for="(type, index) in proprtyTypes"
                                      :key="index"
                                      v-bind:value="type.id"
                                      >{{ type.type }}</option
                                    >
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="subtype"
                                    >Property Sub-type
                                    <span class="required_asterix"
                                      >*</span
                                    ></label
                                  >
                                  <select
                                    v-model="subtype"
                                    id="subtype"
                                    name="subtype"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option
                                      v-for="(subType,
                                      index) in proprtySubTypes"
                                      :key="index"
                                      v-bind:value="subType.id"
                                      >{{ subType.subtype }}</option
                                    >
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-6 d-none" v-if="type != '4'">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="bedrooms"
                                    >Bedrooms
                                    </label
                                  >
                                  <select
                                    v-model="bedrooms"
                                    id="bedrooms"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                                    <option>0</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 d-none" v-if="type != '4'">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="bathrooms"
                                    >Bathrooms
                                    <!-- <span class="required_asterix"
                                      >*</span
                                    > -->
                                  </label>
                                  <select
                                    v-model="bathrooms"
                                    id="bathrooms"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                                    <option>0</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 d-none" v-if="type != '4'">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="toilets"
                                    >Toilets
                                    <!-- <span class="required_asterix"
                                      >*</span
                                    > -->
                                  </label>
                                  <select
                                    v-model="toilets"
                                    id="toilets"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                                    <option>0</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="footage"
                                    >Square meters</label
                                  >
                                  <input
                                    v-model="squarefootage"
                                    id="price"
                                    class="form-control form-select"
                                    type="text"
                                    placeholder="E.g 100"
                                  />

                                  <!-- <select
                                    id="footage"
                                    class="form-control form-select"
                                  >
                                    <option>--select--</option>
                                  </select> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="duration"
                                    >Duration of offer (in years)
                                    <!-- <span class="required_asterix"
                                      >*</span
                                    > -->
                                  </label>
                                  <select
                                    v-model="duration"
                                    id="duration"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >

                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6" v-if="type != '4'">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="status"
                                    >Parking space
                                    <!-- <span class="required_asterix"
                                      >*</span
                                    > -->
                                  </label>
                                  <select
                                    id="parking"
                                    class="form-control form-select"
                                    v-model="parking"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                                    <option>0</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="mode"
                                    >Mode of Acquisition
                                    <span class="required_asterix"
                                      >*</span
                                    ></label
                                  >
                                  <select
                                    v-model="modeofaquisition"
                                    id="mode"
                                    name="mode"
                                    class="form-control form-select"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option
                                      v-for="(moa, index) in mode"
                                      :key="index"
                                      v-bind:value="moa"
                                      >{{ moa }}</option
                                    >
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 d-none">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="status"
                                    >Status of property
                                    <!-- <span class="required_asterix"
                                      >*</span
                                    > -->
                                  </label>
                                  <select
                                    id="status"
                                    class="form-control form-select"
                                    v-model="status"
                                  >
                                    <option value="" selected disabled
                                      >--select--</option
                                    >
                                    <option
                                      v-for="(status, index) in propStatus"
                                      :key="index"
                                      v-bind:value="status"
                                      >{{ status }}</option
                                    >
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="title-wrap">
                            <div class="form-group">
                              <label class="select-label" for="title"
                                >Description
                                <span class="required_asterix">*</span></label
                              >
                              <textarea
                                id="description"
                                class="form-control form-select"
                                type="text"
                                placeholder="Enter Property Description"
                                v-model="description"
                              >
                              </textarea>
                            </div>
                          </div>
                        </div>


                      </div>
                      <div class="col-md-8 details-second-section">
                        <div class="facility-checkbox">
                          <div class="container">
                            <div class="row">
                              <!-- col-md-12 -->
                              <div class="">
                                <p
                                  class="feature-text"
                                  @click="features = !features"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Click"
                                >
                                  Select Property Facilities
                                  <i
                                    class="fa fa-arrow-down "
                                    :class="features ? 'arrow_up' : 'bounce'"
                                  ></i>
                                </p>
                                <div class="check-box-facility" v-if="features">
                                  <div
                                    class="checkbox-wrap"
                                    v-for="(facility, index) in facilitiesTypes"
                                    :key="index"
                                  >
                                    <div
                                      class="custom-control custom-checkbox mb-3"
                                    >
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="facility"
                                        name="facility"
                                        v-bind:value="facility"
                                        v-model="facilities"
                                      />
                                      <label
                                        class="custom-control-label facility-check"
                                        :for="facility"
                                        >{{ facility }}</label
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-md-4 newfacility_div"
                                  v-if="features"
                                >
                                  <input
                                    class="form-control new_feature"
                                    v-model="newfacility"
                                    type="text"
                                    placeholder="Add features if not avalaible"
                                  />
                                  <button
                                    v-if="newfacility"
                                    ref="newF"
                                    @click.prevent="addNewFacility()"
                                    class="btn newfacility_btn"
                                  >
                                    Add
                                    <i
                                      class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                      v-if="loaderFacili"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="nextBtn propertyBtn col-md-10">
                        <button
                          @click.prevent="firstNextBtn()"
                          class="btn"
                          id="fb"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page">
                <div class="property-location">
                  <div class="details-body">
                    <div class="col-md-8 details-header">
                      <div class="details-header-text">
                        <p>Property Location & Pricing</p>
                      </div>
                    </div>
                    <div class="col-md-8 details-first-section">
                      <div class="container pb-3">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="country"
                                  >Country
                                  <span class="required_asterix">*</span></label
                                >
                                <select
                                  @change="getStates()"
                                  id="country"
                                  class="form-control form-select"
                                  v-model="countryId"
                                >
                                  <option value="" selected disabled
                                    >--select--</option
                                  >
                                  <option
                                    v-for="(country, index) in countries"
                                    :key="index"
                                    v-bind:value="country.id"
                                    >{{ country.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="state"
                                  >State
                                  <span class="required_asterix">*</span></label
                                >
                                <select
                                  @change="getCities()"
                                  id="state"
                                  class="form-control form-select"
                                  v-model="stateid"
                                >
                                  <option value="" selected disabled
                                    >--select--</option
                                  >
                                  <option
                                    v-for="(state, index) in states"
                                    :key="index"
                                    v-bind:value="state.id"
                                    >{{ state.name }}</option
                                  >
                                </select>
                                <!-- {{ state.id }} -->
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="city"
                                  >City
                                  <span class="required_asterix">*</span></label
                                >
                                <select
                                  id="city"
                                  class="form-control form-select"
                                  v-model="cityid"
                                >
                                  <option value="" selected disabled
                                    >--select--</option
                                  >
                                  <option
                                    v-for="(city, index) in cities"
                                    :key="index"
                                    v-bind:value="city.id"
                                    >{{ city.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="address"
                                  >Address
                                  <span class="required_asterix">*</span></label
                                >
                                <input
                                  id="title"
                                  class="form-control form-select"
                                  type="text"
                                  placeholder="Enter property address"
                                  v-model="address"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4" v-if="type != '1' && type != ''">
                              <div class="form-wrap">
                                <div class="form-group">
                                  <label class="select-label" for="price"
                                    >Annual Rent Rate
                                    <span class="required_asterix">*</span></label
                                  >
                                  <input
                                    id="price"
                                    class="form-control form-select"
                                    placeholder="E.g 1,500,000"
                                    v-model="price2"
                                    onfocus="(this.type='text')"
                                  />
                                  <!-- <select
                                      id="price"
                                      class="form-control form-select"
                                    >
                                      <option>--select--</option>
                                    </select> -->
                                </div>
                              </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="denomination"
                                  >Denomination
                                  <span class="required_asterix">*</span></label
                                >
                                <select
                                  id="denomination"
                                  class="form-control form-select"
                                  v-model="denomination"
                                >
                                  <option value="" selected disabled
                                    >--select--</option
                                  >
                                  <option
                                    :disabled="denomination === 'USD'"
                                    v-for="(denomination,
                                    index) in denominations"
                                    :key="index"
                                    v-bind:value="denomination"
                                    >{{ denomination }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-wrap">
                              <div class="form-group">
                                <label class="select-label" for="mop"
                                  >Mode of payment
                                  <span class="required_asterix">*</span></label
                                >
                                <select
                                  id="mop"
                                  class="form-control form-select"
                                  v-model="modeofpayment"
                                >
                                  <option value="" selected disabled
                                    >--select--</option
                                  >
                                  <option
                                    v-for="(mop, index) in modeOfPayments"
                                    :key="index"
                                    v-bind:value="mop"
                                    >{{ mop }}</option
                                  >
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 details-second-section" v-if="type == '1' && type != ''">
                      <div class="container pb-3">
                         <!-- v-if="type == '1' && type != ''" -->
                         <div class="container pb-3">
                          <div>
                            <!-- <h3>Add Units</h3> -->
                            <div class="addNewUnit">
                              <div class="unit-text-button">
                                <h5>Units</h5>
                                <button class="btn" @click.prevent="addForm()"><span>+</span> Add unit</button>
                              </div>
                              <h6>Add the individual units within this property. Each unit can be tracked and updated separately.</h6>
                            </div>
                          </div>

                          <div v-for="(form, index) in forms" :key="index">
                            <div class="unit-count-holder">
                              <h3>Unit {{ index + 1 }}</h3>
                              <div>
                                <!-- <small>Save</small> -->
                                <img style="cursor: pointer;" v-if="forms.length > 1 && index != 0" @click="removeForm(index)" src="../assets/icons/trash.svg" alt="delete">
                              </div>
                            </div>
                            <div class="" @submit.prevent="submitForm(index)">
                             <div class="">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="subtype"
                                        >Unit name
                                        <span class="required_asterix"
                                          >*</span
                                        ></label
                                      >
                                      <select
                                        v-model="form.unit_name"
                                        :id="index"
                                        name="unitname"
                                        class="form-control form-select"
                                      >
                                        <option value="" selected disabled
                                          >--select--</option
                                        >
                                        <option
                                          v-for="(category, index) in propertyCategory"
                                          :key="index"
                                          :value="category"
                                          >{{ category }}</option
                                        >
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="unitamount"
                                        >Unit amount
                                        <span class="required_asterix">*</span></label
                                      >
                                      <input
                                        id="unitamount"
                                        maxlength="40"
                                        class="form-control form-select"
                                        type="text"
                                        @input="formatPrice(index)"
                                        placeholder="Enter Unit Amount"
                                        v-model="form.price"
                                      />
                                    </div>
                                  </div>

                                  
                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="subtype"
                                        >Number of Bedrooms
                                        <span class="required_asterix"
                                          >*</span
                                        ></label
                                      >
                                      <select
                                        v-model="form.bedrooms"
                                        :id="index"
                                        name="bedrooms"
                                        class="form-control form-select"
                                      >
                                        <option value="" selected disabled
                                          >--select--</option
                                        >
                                        <option  value="1">1</option>
                                        <option value="2">2</option>
                                        <option class="3">3</option>
                                        <option class="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="subtype"
                                        >Number of Bathrooms
                                        <span class="required_asterix"
                                          >*</span
                                        ></label
                                      >
                                      <select
                                        v-model="form.bathrooms"
                                        :id="index"
                                        name="bathrooms"
                                        class="form-control form-select"
                                      >
                                        <option value="" selected disabled
                                          >--select--</option
                                        >
                                        <option  value="1">1</option>
                                        <option value="2">2</option>
                                        <option class="3">3</option>
                                        <option class="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                      </select>
                                    </div>
                                  </div>


                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="subtype"
                                        >Number of Toilets
                                        <span class="required_asterix"
                                          >*</span
                                        ></label
                                      >
                                      <select
                                        v-model="form.toilets"
                                        :id="index"
                                        name="toilets"
                                        class="form-control form-select"
                                      >
                                        <option value="" selected disabled
                                          >--select--</option
                                        >
                                        <option  value="1">1</option>
                                        <option value="2">2</option>
                                        <option class="3">3</option>
                                        <option class="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                      </select>
                                    </div>
                                  </div>


                                  <div class="col-md-6">
                                    <div class="form-group mt-4">
                                      <label class="select-label" for="subtype"
                                        >Status
                                        <span class="required_asterix"
                                          >*</span
                                        ></label
                                      >
                                      <select
                                        v-model="form.status"
                                        :id="index"
                                        name="status"
                                        class="form-control form-select"
                                      >
                                        <option value="" selected disabled
                                          >--select--</option
                                        >
                                        <option
                                          v-for="(status, index) in propStatus"
                                          :key="index"
                                          v-bind:value="status"
                                          >{{ status }}</option
                                        >
                                        <!-- <option
                                          v-for="status in propertyStatuses"
                                          :key="status"
                                          :value="status"
                                          >{{ status }}</option
                                        > -->
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group mt-4">
                              <label class="select-label" for="unitamount"
                                >Number of units to replicate (optional): <span>{{ forms.length }}</span>
                                </label
                              >
                              <input
                                id="unitNumber"
                                class="form-control form-select"
                                type="number"
                                placeholder="Enter number of units.."
                                v-model="duplicateFormNumber"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-md-8 details-second-section">
                    </div> -->
                    <div class="col-md-8 details-btn-wrap">
                      <div class="detail-btn-holder">
                        <button
                          @click.prevent="pevBtnSecd()"
                          class="btn  prev-1"
                        >
                          Back
                        </button>
                        <button
                          @click.prevent="nextBtnSecd()"
                          class="btn next-1"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- <button
                    @click.prevent="pevBtnSecd()"
                    class="btn btn-secondary prev-1"
                  >
                    Prev
                  </button>
                  <button
                    @click.prevent="nextBtnSecd()"
                    class="btn btn-primary next-1"
                  >
                    Next
                  </button> -->
                </div>
              </div>
              <!-- media -->
              <div class="page">
                <div class="property-documents">
                  <div class="details-body">
                    <div class="col-md-8 details-header">
                      <div class="details-header-text">
                        <p>Property Documents & Media</p>
                      </div>
                    </div>
                    <div class="col-md-8 details-first-section">
                      <div class="container pb-3">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-wrap">
                              <p class="upload-header">
                                Upload Evidence of ownership
                              </p>
                              <div
                                v-if="!evidenceUpload"
                                class="upload-file-holder"
                              >
                                <div
                                  class="file-holder"
                                  @click="$refs.evi.click()"
                                >
                                  <img
                                    src="../assets/images/uploadfile.svg"
                                    alt="file"
                                  />
                                  <input
                                    ref="evi"
                                    type="file"
                                    name="evidence"
                                    id="evi"
                                    class="d-none"
                                    @change="evidenceOfOwnership($event)"
                                  />
                                  <p v-if="!uploadingData">
                                    Drag and drop or
                                    <span class="browse">browse</span> your
                                    files
                                  </p>
                                  <h6
                                    class="uploading_text"
                                    v-if="uploadingData"
                                  >
                                    Uploading please wait...
                                  </h6>
                                </div>
                              </div>
                              <div v-else class="upload-file-holder">
                                <div
                                  class="file-holder file_uploaded_successfully"
                                  @click="$refs.evi.click()"
                                >
                                  <img
                                    src="../assets/images/check-uploaded.svg"
                                    alt="file"
                                  />
                                  <input
                                    ref="evi"
                                    type="file"
                                    name="evidence"
                                    id="evi"
                                    class="d-none"
                                    @change="evidenceOfOwnership($event)"
                                  />
                                  <p>
                                    File uploaded successfully
                                  </p>
                                </div>
                              </div>
                              <p class="file-type">
                                Supported file formats PNG, JPEG, GIF or PDF
                              </p>
                              <!-- <h6 class="uploading_text" v-if="uploadingData">
                                Uploading please wait...
                              </h6> -->
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-wrap">
                              <p class="upload-header">
                                Upload Property Images
                              </p>
                              <div
                                v-if="!propertyImageUppload"
                                class="upload-file-holder"
                              >
                                <div
                                  class="file-holder"
                                  @click="$refs.propp.click()"
                                >
                                  <img
                                    src="../assets/images/uploadfile.svg"
                                    alt="file"
                                  />
                                  <!-- <img@click="$refs.files.click()"
                                  src="../assets/images/uploadfile.svg" alt=""> -->
                                  <input
                                    ref="propp"
                                    type="file"
                                    name="evidence"
                                    id="propps"
                                    class="d-none"
                                    multiple
                                    @change="uploadThePropertyImage()"
                                  />
                                  <!-- <input
                                    ref="files"
                                    type="file"
                                    name="evidence"
                                    id="evi"
                                    class="d-none"
                                    multiple
                                    @change="uploadPropertyImages"
                                  /> -->
                                  <p v-if="!uploadingData2">
                                    Drag and drop or
                                    <span class="browse">browse</span> your
                                    files
                                  </p>
                                  <h6
                                    class="uploading_text"
                                    v-if="uploadingData2"
                                  >
                                    Uploading please wait...
                                  </h6>
                                </div>
                              </div>
                              <div v-else class="upload-file-holder">
                                <div
                                  class="file-holder file_uploaded_successfully"
                                  @click="$refs.propp.click()"
                                >
                                  <img
                                    src="../assets/images/check-uploaded.svg"
                                    alt="file"
                                  />
                                  <input
                                    ref="propp"
                                    type="file"
                                    name="evidence"
                                    id="propps"
                                    class="d-none"
                                    multiple
                                    @change="uploadThePropertyImage()"
                                  />
                                  <p>
                                    File uploaded successfully
                                  </p>
                                </div>
                              </div>

                              <p class="file-type">
                                Supported file formats PNG, JPEG, GIF or PDF
                              </p>
                              <!-- <div class="field pb-3">
                                  <div v-for="(file, index) in files" :key="index" :class="`level  ${file.invalidMessage && 'has-text-danger'} ${!file.invalidMessage && 'has-text-success'} `">
                                    <div class="level-left">
                                      <div class="level-item">
                                        {{ file.name }}
                                        <span v-if="file.invalidMessage">&nbsp;- {{file.invalidMessage}}</span>
                                      </div>
                                    </div>
                                    <div class="level-right">
                                      <div class="level-item">
                                       <a @click.prevent="files.splice(index, 1); uploadFiles.splice(index, 1)" href="" class="delete"><p class="remove-file">X</p></a>
                                      </div>
                                    </div>
                                  </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                        <div class="tm">
                          <div class="custom-control custom-checkbox mb-3">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="tearm-condition"
                              :value="acceptedterms"
                              v-model="acceptedterms"
                            />
                            <label
                              class="custom-control-label facility-check"
                              for="tearm-condition"
                              >I hereby declare that the information presented
                              therein are true and correct and that i will be
                              liable for any false information given
                              thereof.</label
                            >
                            <!-- {{acceptedterms}} -->
                          </div>
                          <hr />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-8 details-btn-wrap">
                      <div class="detail-btn-holder">
                        <button
                          @click.prevent="prevBtnThird()"
                          class="btn  prev-2"
                        >
                          Back
                        </button>
                        <button
                          @click.prevent="addProperties()"
                          class="btn next-2"
                        >
                          Finish
                          <i
                            class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                            v-if="loader"
                          ></i>
                        </button>
                        <!-- <button
                          @click.prevent="
                            addProperties();
                          "
                          class="btn next-2"
                        >
                          Finish
                          <i
                            class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                            v-if="loader"
                          ></i>
                        </button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page slidepage">
                <div class="property-fininish">
                  <div class="details-body">
                    <div class="col-md-8 details-header">
                      <div class="details-header-text">
                        <p>Finish</p>
                      </div>
                    </div>
                    <div class="col-md-8 details-first-section">
                      <div class="container pb-3">
                        <div class="good-finished">
                          <img
                            src="../assets/images/check-good.svg"
                            alt="finished"
                          />
                        </div>
                        <p class="got-covered-text">
                          .... We Got You Covered !
                        </p>
                      </div>
                    </div>
                    <div class="col-md-8 details-btn-wrap">
                      <div class="start-btn-holder">
                        <button @click.prevent="prevBtnFourth()" class="btn">
                          BACK
                        </button>
                      </div>
                    </div>
                    <!-- <button
                      @click.prevent="prevBtnFourth()"
                      class="btn btn-secondary prev-3"
                    >
                      Prev
                    </button>
                    <button
                      @click.prevent="submitBtn()"
                      class="btn btn-success"
                    >
                      Start again
                    </button> -->
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- <FooterMain /> -->
    </div>
  </div>
</template>

<script>
// import FooterMain from "../views/FooterMain";
// import Header from "../views/Header";
import _ from "lodash";
import { Service } from "../store/service";
const Api = new Service();
import Vue from "vue";
import { nextTick } from 'vue';

export default {
  name: "AddProperty",
  components: {
    // Header,
    // FooterMain
  },
  data() {
    return {
      currentStep: null,
      scrollPosition: null,
      evidenceUpload: false,
      propertyImageUppload: false,
      uploadingData: false,
      uploadingData2: false,
      features: false,
      title: "",
      // propertyTypeId: "",
      // propertySubTypeId: "",
      proprtyTypes: "",
      proprtySubTypes: "",
      businessTypes: "",
      // businessType: "",
      businesstype: "",
      type: "",
      subtype: "",
      bathrooms: "",
      bedrooms: "",
      toilets: "",
      squarefootage: "",
      duration: "",
      facilitiesTypes: "",
      duplicateFormNumber: '',
      facilities: [],
      newfacility: "",
      countryId: "",
      countries: "",
      states: "",
      stateid: "",
      cityid: "",
      cities: "",
      modeofaquisition: "",
      mode: "",
      propStatus: "",
      status: "",
      address: "",
      price: "",
      price2: "",
      denomination: "",
      denominations: "",
      modeOfPayments: "",
      modeofpayment: "",
      evidenceofownership: "",
      files: [],
      uploadFiles: [],
      message: "",
      error: false,
      propertyimages: "",
      propimgname: "",
      eviownship: "",
      file: "",
      file2: [],
      images: [],
      fileSizeInMb: "",
      fileName: "",
      formData: "",
      thefileprop: "",
      acceptedterms: "",
      description: "",
      parking: "",
      id: "",
      loader: false,
      loaderFacili: false,

      propertyCategory: [],
      propertyStatuses: [],
      forms: [
          {
            unit_name: '',
            price: '',
            bedrooms: '',
            bathrooms: '',
            toilets: '',
            status: '',
          },
        ],
    };
  },
  mounted() {
    this.id = JSON.parse(localStorage.getItem("shelta-user")).id;
    // this.getUserProfile(this.id);
    window.addEventListener("scroll", this.updateScroll);
    this.getPropertyTypes();
    this.getBusinessType();
    this.getModeOfAquisition();
    this.getPropertyStatus();
    this.getFacilities();
    this.getCountries();
    this.getDenimination();
    this.getModeOfPayments();
    this.getPropCategory();
    // this.getStates
  },
  watch: {
    price2: function(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.price2 = result));
      this.price = this.price2.split(",").join("");
    },
    duplicateFormNumber(newData, oldData) {
      newData = String(newData); 
      if (newData.startsWith("0")) {
        return this.$toast.error("Number of unit can't be 0");
      }
      if (newData) {
       this.duplicateFormData(newData, oldData);
      }
    },
    type(newData, oldData) {
      newData = String(newData); 
      if (newData != 1) {
       this.forms = [
          {
            unit_name: '',
            price: '',
            bedrooms: '',
            bathrooms: '',
            toilets: '',
            status: '',
          },
       ];
      }
      else {
        this.price = '';
      }
      
    },

  },
  methods: {
    backtohome: function() {
      this.$router.push("/shelta");
    },

    // Do not remove this function as it triggers a submit to add new facility
    callEvent(e) {
      // //  console.log("triger submit", e.keyCode);
      //  if (e.keyCode == 13) {
      //   this.$refs.newF.click();
      //   console.log("triger submit");
      // }
    },
    getPropCategory() {
      Api.getRequest(`fetch-shelta-property-categories`)
        .then((data) => {
          // console.log("Category", data);
          if (data.data.success) {
            // this.propertyCategory = data.categories;
            this.propertyCategory = data.data.updated_category;
          }
          // this.loadingLocation = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addNewFacility: async function() {
      this.loaderFacili = true;
      this.$store.commit("setApiWarning", "Adding new feature...");
      try {
        await Api.postRequest(`addfeatureandfacility`, {
          facility: this.newfacility,
          userid: this.id
        })
          .then(res => {
            this.loaderFacili = false;
            this.getFacilities();
            this.newfacility = "";
            this.$store.commit("setApiSuccess", "Success");
          })
          .catch(err => {
            this.loaderFacili = false;
            // console.log(err);
            this.$store.commit("setApiFailed", "An error occured");
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    addProperties: async function() {
      this.loader = true;
      //     acceptedterms: this.acceptedterms,
      if (this.evidenceofownership === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Add evidence of ownership");
      }
      if (this.propertyimages === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Add property image");
      }
      if (this.acceptedterms === false || this.acceptedterms === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Thick terms and condition");
      }
      let updatedArray = this.forms.map((item) => ({
          ...item,
          price: item.price.replace(/,/g, ""),
        }));
      // let isSubType = ''; 
      // if (this.type != '1') {
      //   isSubType = this.subtype;
      //   updatedArray = [];
      // }
      try {
        await Api.postRequest(`addproperty2`, {
          title: this.title,
          businesstype: this.businesstype,
          modeofpayment: this.modeofpayment,
          denomination: this.denomination,
          price: parseInt(this.price),
          address: this.address,
          cityid: parseInt(this.cityid),
          stateid: parseInt(this.stateid),
          modeofaquisition: this.modeofaquisition,
          status: this.status,
          duration: this.duration,
          squarefootage: this.squarefootage,
          bathrooms: this.bathrooms,
          toilets: this.toilets,
          bedrooms: this.bedrooms,
          type: this.type,
          subtype: this.subtype,
          userid: this.id,
          unit_objects: updatedArray,
          evidenceofownership: this.evidenceofownership,
          acceptedterms: this.acceptedterms,
          // city: this.city,
          // state: this.state,
          facilities: this.facilities,
          parking: this.parking,
          description: this.description,
          propertyimages: this.propertyimages
          // images: this.images
        })
          .then(res => {
            this.loader = false;
            if (res.data.success) {
              this.evidenceOfOwnership = "";
              this.eviownship = "";
              this.propertyimages = "";
              this.propimgname = "";
              this.nextBtnThird();
              // this.countries = res.data.property;
              // this.getStates();
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            this.loader = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    uploadPropertyImages: async function(event) {
      const files = this.$refs.files.files;
      this.uploadFiles = [...this.uploadFiles, ...files];
      this.files = [
        ...this.files,
        ..._.map(files, file => ({
          name: file.name,
          size: file.size,
          type: file.type,
          invalidMessage: this.validate(file)
        }))
      ];
      this.uploadFileProperty();
    },
    validate: function(file) {
      const MAX_SIZE = 200000;
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "application/pdf",
        "svg+xml"
      ];
      if (file.size > MAX_SIZE) {
        return `Max size: ${MAX_SIZE / 1000}Kb`;
      }
      if (!allowedTypes.includes(file.type)) {
        return "Not an image";
      }
      if (file.type === "") {
        return "No file was selected";
      }
      return "";
    },
    uploadFileProperty: async function() {
      this.$store.commit("setApiWarning", "Uploading....");
      _.forEach(this.uploadFiles, file => {
        if (this.validate(file) === "") {
          this.formData = new FormData();
          this.formData.append("file", file);
        }
      });
      try {
        await Api.postRequest(`uploadpropertyimage`, this.formData)
          .then(res => {
            this.files = [];
            this.uploadFiles = [];
            if (res.data.error) {
              // this.fileSizeType = true;
              return this.$store.commit("setApiFailed", res.data.error);
            } else if (res.data.success) {
              // this.images = res.data.url;
              this.images = res.data.filename;
              this.$store.commit("setApiSuccess", res.data.success);
            }
          })
          .catch(err => {
            this.loader2 = false;
            // console.log(err);
          });
      } finally {
        console.log("");
      }
    },
    uploadThePropertyImage: async function(event) {
      // this.$store.commit("setApiWarning", "Uploading...");
      this.uploadingData2 = true;
      this.file = this.$refs.propp.files[0];
      // console.log("File type", this.file.type);
      // console.log("Fillllllllllle", this.file, "File type:", this.file.type);
      this.propertyimages = this.file.name;
      if (!this.file) {
        this.loader2 = false;
        return this.$store.commit("setApiFailed", "Nothing was selected!");
      }
      if (
        this.file.type === "image/jpeg" ||
        this.file.type === "image/jpg" ||
        this.file.type === "image/png" ||
        this.file.type === "image/gif" ||
        this.file.type === "application/pdf" ||
        this.file.type === "svg+xml"
      ) {
        // this.loader2 = true;
        this.uploadingData2 = true;
      } else {
        // this.loader2 = false;
        this.uploadingData2 = false;
        return this.$store.commit(
          "setApiFailed",
          "Please select an appropiate image file"
        );
      }
      const formData = new FormData();
      const sizeInMB = (this.file.size / (1024 * 1024)).toFixed(3);
      this.fileSizeInMb = sizeInMB;
      formData.append("file", this.file);
      if (sizeInMB > 5) {
        this.fileSizeType = true;
        this.loader2 = false;
        // this.$store.commit("setApiWarning", "");
        return this.$store.commit(
          "setApiFailed",
          "File size too large, should be more than 5MB"
        );
      } else {
        try {
          await Api.postRequest(`uploadpropertyimage`, formData)
            .then(res => {
              this.$store.commit("setApiWarning", "");
              this.loader2 = false;
              if (res.data.error) {
                // this.fileSizeType = true;
                return this.$store.commit("setApiFailed", res.data.error);
              } else if (res.data.success) {
                this.propertyImageUppload = true;
                this.uploadingData2 = false;
                this.propertyimages = res.data.filename;
                this.propimgname = res.data.filename;
                this.$store.commit("setApiSuccess", "success");
              }
            })
            .catch(err => {
              // this.loader2 = false;
              this.uploadingData2 = false;
            });
        } finally {
          // console.log("Closed connection");
        }
      }
    },
    evidenceOfOwnership: async function(event) {
      // this.$store.commit("setApiWarning", "Uploading...");
      this.uploadingData = true;
      this.file = this.$refs.evi.files[0];
      // console.log("Fillllllllllle", this.file, "File type:", this.file.type);
      this.eviownship = this.file.name;
      if (!this.file) {
        this.loader2 = false;
        this.uploadingData = false;
        return this.$store.commit("setApiFailed", "Nothing was selected!");
      }
      if (
        this.file.type === "image/jpeg" ||
        this.file.type === "image/jpg" ||
        this.file.type === "image/png" ||
        this.file.type === "image/gif" ||
        this.file.type === "application/pdf" ||
        this.file.type === "svg+xml"
      ) {
        // this.loader2 = true;
        this.uploadingData = true;
      } else {
        // this.loader2 = false;
        this.uploadingData = false;
        this.$store.commit("setApiWarning", "");
        // this.uploadingData = false;
        return this.$store.commit(
          "setApiFailed",
          "Please select a pdf or image file"
        );
      }
      const formData = new FormData();
      const sizeInMB = (this.file.size / (1024 * 1024)).toFixed(3);
      this.fileSizeInMb = sizeInMB;
      formData.append("file", this.file);
      if (sizeInMB > 5) {
        this.fileSizeType = true;
        this.loader2 = false;
        return this.$store.commit(
          "setApiFailed",
          "File size too large, should be more than 5MB"
        );
      } else {
        try {
          await Api.postRequest(`uploadevidenceofownership`, formData)
            .then(res => {
              this.$store.commit("setApiWarning", "");
              // this.loader2 = false;
              this.uploadingData = false;
              if (res.data.error) {
                // this.fileSizeType = true;
                return this.$store.commit("setApiFailed", res.data.error);
              } else if (res.data.success) {
                this.evidenceUpload = true;
                this.uploadingData = false;
                this.file = "";
                // this.evidenceofownership = res.data.url;
                this.eviownship = res.data.filename;
                this.evidenceofownership = res.data.filename;
                this.$store.commit(
                  "setApiSuccess",
                  "Evidence of ownnership updated"
                );
              }
            })
            .catch(err => {
              // this.loader2 = false;
              this.uploadingData = false;
              // console.log(err);
            });
        } finally {
          // console.log("Closed connection");
        }
      }
    },
    getCountries: async function() {
      // this.$store.commit("setApiWarning", "Loading countries...");
      try {
        // fetchallcountries Api for countries only in Nigeria
        await Api.getRequest(`fetchallcountries`)
          .then(res => {
            this.$store.commit("setApiWarning", "Loading");
            if (res.data.success) {
              this.countries = res.data.countries;
              // this.getStates();
              // return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getCities: async function() {
      const id = this.stateid;
      this.$store.commit("setApiWarning", "Loading cities");
      try {
        await Api.getRequest(`fetchcitiesbystateid/${id}`)
          .then(res => {
            this.$store.commit("setApiWarning", "");
            if (res.data.success) {
              this.cities = res.data.cities;
              // return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getDenimination: async function() {
      try {
        await Api.getRequest(`fetchdenomination`)
          .then(res => {
            if (res.data.success) {
              this.denominations = res.data.denomination;
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getModeOfPayments: async function() {
      try {
        await Api.getRequest(`fetchmodeofpayment`)
          .then(res => {
            if (res.data.success) {
              this.modeOfPayments = res.data.modeofpayment;
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getStates: async function() {
      const id = this.countryId;
      // this.$store.commit("setApiWarning", "Loading state...");
      try {
        await Api.getRequest(`fetchstatesbycountryid/${id}`)
          .then(res => {
            this.$store.commit("setApiWarning", "");
            if (res.data.success) {
              this.states = res.data.states;
              // return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getFacilities: async function() {
      try {
        await Api.getRequest(`fetchfacilities`)
          .then(res => {
            if (res.data.success) {
              this.facilitiesTypes = res.data.facilities;
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getBusinessType: async function() {
      try {
        await Api.getRequest(`fetchbusinesstypes`)
          .then(res => {
            if (res.data.success) {
              this.businessTypes = res.data.businesstype;
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    // getTypeInfo: function(event) {
    //   // console.log("check", event.target.value);
    //   this.propertyTypeId = event.target.value;
    //   this.getPropertySubTypes();
    // },
    getSubTypeInfo: function(event) {
      this.getPropertySubTypes();
    },
    // getMode: function(event) {
    //   console.log("goat", event.target.value);
    //   this.modeofaquisition = event.target.value
    // },
    // getStatus: function(event) {
    //   console.log(event.target.value);
    //   this.status = event.target.value;
    // },
    getPropertyStatus: async function() {
      try {
        await Api.getRequest(`fetchpropertystatuses`)
          .then(res => {
            if (res.data.success) {
              this.propStatus = res.data.propertystatus;
              // return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getModeOfAquisition: async function() {
      try {
        await Api.getRequest(`fetchmethodofaquisition`)
          .then(res => {
            if (res.data.success) {
              this.mode = res.data.modeofaquisition;
              // return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getPropertySubTypes: async function() {
      const id = this.type;
      this.$store.commit("setApiWarning", "Loading property subtype...");
      try {
        await Api.getRequest(`fetchpropertysubtypesbytypeid/${id}`)
          .then(res => {
            this.$store.commit("setApiWarning", "");
            if (res.data.success) {
              this.proprtySubTypes = res.data.propertysubtypes;
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getPropertyTypes: async function() {
      this.$store.commit("setApiWarning", "Loading property types...");
      try {
        await Api.getRequest(`fetchpropertytypes`)
          .then(res => {
            this.$store.commit("setApiWarning", "");
            if (res.data.success) {
              this.proprtyTypes = res.data.propertytypes;
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            // this.loader2 = false;
            // console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    firstNextBtn: function() {
      if (
        this.title === "" ||
        this.businesstype === "" ||
        // (this.type === "") && (this.type == "4") ||
        this.type === "" ||
        this.subtype == "" ||
        // (this.bathrooms === "" && this.type != "4") ||
        // (this.bedrooms === "" && this.type != "4") ||
        // (this.toilets === "" && this.type != "4") ||
        // this.squarefootage === "" ||
        // this.duration === "" ||
        // this.status === "" ||
        this.modeofaquisition === "" ||
        this.description === ""
        // (this.parking === "" && this.type != "4")
      ) {
        return this.$store.commit(
          "setApiFailed",
          "Fill all required form before going to next"
        );
      } else {
        const slidePage = document.querySelector(".slidepage");
        const preogressText = document.querySelectorAll(".step p");
        const progresCheck = document.querySelectorAll(".step .check");
        const bullet = document.querySelectorAll(".step .bullet");

        const max = 4;
        let current = 1;

        slidePage.style.marginLeft = "-25%";
        bullet[current - 1].classList.add("active");
        preogressText[current - 1].classList.add("active");
        progresCheck[current - 1].classList.add("active");
        current += 1;
        const elmnt = document.getElementsByClassName("page");
        elmnt[0].scrollIntoView();
      }
    },
    nextBtnSecd() {
      if (
        this.countryId === "" ||
        this.stateid === "" ||
        // this.cityid === "" ||
        this.address === "" ||
        // this.price === "" ||
        this.denomination === ""
      ) {
        return this.$store.commit(
          "setApiFailed",
          "Fill all required form before going next"
        );
      } 
      const lastForm = this.forms[this.forms.length - 1];
      if (this.type == '1' ) {
        if (!lastForm.unit_name || !lastForm.price || !lastForm.bedrooms || !lastForm.bathrooms || !lastForm.toilets || !lastForm.status )
         return this.$store.commit("setApiFailed", "Fill all unit forms");
      }
      if (this.type != '1' &&  this.price === "") {
        return this.$store.commit(
          "setApiFailed",
          "Fill property price"
        );
      }
      else {
        const slidePage = document.querySelector(".slidepage");
        const preogressText = document.querySelectorAll(".step p");
        const progressCheck = document.querySelectorAll(".step .check");
        const bullet = document.querySelectorAll(".step .bullet");

        const max = 4;
        let current = 1;

        slidePage.style.marginLeft = "-50%";
        bullet[current - 0].classList.add("active");
        preogressText[current - 0].classList.add("active");
        progressCheck[current - 0].classList.add("active");
        current += 1;
        const elmnt = document.getElementsByClassName("page");
        elmnt[0].scrollIntoView();
      }
    },
    nextBtnThird() {
      _.forEach(this.uploadFiles, file => {
        if (this.validate(file) === "") {
          this.thefileprop = file;
          this.formData = new FormData();
          this.formData.append("file", file);
          // console.log("Multiple file check", file);
        }
      });
      if (this.evidenceofownership === "") {
        return this.$store.commit("setApiFailed", "Select file");
      } else {
        const slidePage = document.querySelector(".slidepage");

        const preogressText = document.querySelectorAll(".step p");
        const progressCheck = document.querySelectorAll(".step .check");
        const bullet = document.querySelectorAll(".step .bullet");

        const max = 4;
        let current = 1;

        slidePage.style.marginLeft = "-75%";
        bullet[current + 1].classList.add("active");
        preogressText[current + 1].classList.add("active");
        progressCheck[current + 1].classList.add("active");
        current += 1;
        const elmnt = document.getElementsByClassName("page");
        elmnt[0].scrollIntoView();
      }
    },
    pevBtnSecd: function() {
      const slidePage = document.querySelector(".slidepage");

      const preogressText = document.querySelectorAll(".step p");
      const progressCheck = document.querySelectorAll(".step .check");
      const bullet = document.querySelectorAll(".step .bullet");
      const max = 4;
      let current = 1;

      slidePage.style.marginLeft = "0%";
      bullet[current - 1].classList.remove("active");
      preogressText[current - 1].classList.remove("active");
      progressCheck[current - 1].classList.remove("active");
      current -= 1;
      const elmnt = document.getElementsByClassName("page");
      elmnt[0].scrollIntoView();
    },
    prevBtnThird: function() {
      const slidePage = document.querySelector(".slidepage");
      const preogressText = document.querySelectorAll(".step p");
      const progressCheck = document.querySelectorAll(".step .check");
      const bullet = document.querySelectorAll(".step .bullet");
      //  const preogressText = document.querySelectorAll(".step p");
      //   const progressCheck = document.querySelectorAll(".step .check");
      //   const bullet = document.querySelectorAll(".step .bullet");

      const max = 4;
      let current = 1;

      slidePage.style.marginLeft = "-25%";
      bullet[current - 0].classList.remove("active");
      preogressText[current - 0].classList.remove("active");
      progressCheck[current - 0].classList.remove("active");
      current -= 1;
      const elmnt = document.getElementsByClassName("page");
      elmnt[0].scrollIntoView();
    },
    prevBtnFourth: function() {
      window.location.reload();
    },
    submitBtn: function() {
      const slidePage = document.querySelector(".slidepage");
      const preogressText = document.querySelectorAll(".step p");
      const progressCheck = document.querySelectorAll(".step .check");
      const bullet = document.querySelectorAll(".step .bullet");

      const max = 4;
      let current = 1;

      bullet[current + 2].classList.remove("active");
      preogressText[current + 2].classList.remove("active");
      progressCheck[current + 2].classList.remove("active");
      current += 1;
      const elmnt = document.getElementsByClassName("page");
      elmnt[0].scrollIntoView();
    },

    formatPrice(index) {
      // Remove existing commas
      const unformatedPrice = this.forms[index].price.replace(/,/g, "");
      // Add commas back in
      this.forms[index].price = new Intl.NumberFormat().format(unformatedPrice);
    },
    addForm() {   
      const lastForm = this.forms[this.forms.length - 1]; // Get the last form
      // Validate if all fields of the last form are filled
      
      if (!lastForm.unit_name || !lastForm.price || !lastForm.bedrooms || !lastForm.bathrooms || !lastForm.toilets || !lastForm.status) {
        return this.$store.commit( "setApiFailed", "Please fill in all fields in the unit form before adding a new form.");
        // this.$toast.error("Please fill in all fields in the unit form before adding a new form.");
        // return;
      }
      // Add a new form if validation passes
      this.forms.push({ unit_name: '', price: '', bedrooms: '',  bathrooms: '', toilets: '', status: ''});
      console.log("Last form", lastForm)
      // console.log("Formssss", this.forms);  // Check if a new form is added
    },
    removeForm(index) {
      this.forms.splice(index, 1); // Remove 1 element at the given index
    },
    duplicateFormData(newData, oldData) {
      const lastForm = this.forms[this.forms.length - 1]; 
      if (!lastForm.unit_name || !lastForm.price || !lastForm.bedrooms|| !lastForm.bathrooms || !lastForm.toilets || !lastForm.status) {
        this.$toast.error("Please fill in all fields in the unit form before adding a new form.");
        return;
      }

      if (this.propertyType == 'Residential' ) {
        if (!lastForm.unit_name || !lastForm.price || !lastForm.bedrooms || !lastForm.bathrooms || !lastForm.toilets || !lastForm.status )
         return this.$toast.error("Fill all required forms");
      }

      if (this.propertyType != 'Residential') {
        this.forms = [];
        return this.$toast.error("Fill all required fileds");
      }

      if (newData < 1) return;
      if (newData > oldData) {
        // Add new objects to the array
        const additionalObjects = Array.from(
          { length: newData - oldData },
          () => ({ 
            unit_name: this.forms[0].unit_name,
            price: this.forms[0].price,
            bedrooms: this.forms[0].bedrooms,
            bathrooms: this.forms[0].bathrooms,
            toilets: this.forms[0].toilets,
            status: this.forms[0].status,
          })
        );
        this.forms.push(...additionalObjects);
      } else if (newData < oldData) {
        // Remove excess objects from the array
        this.forms.splice(newData);
      }

      // const duplicatedArray = this.forms.flatMap(item => Array(Number(`${this.duplicateFormNumber}`)).fill({ ...item }));
      // this.forms = duplicatedArray;
      // console.log("Duplicated form", duplicatedArray, this.forms);
    }, 
  },
  updateScroll() {
    this.scrollPosition = window.scrollY;
  },
  computed: {
    // pregressBar() {
    //   const slidePage = document.querySelector(".slidepage");
    //   const firstNextBtn = document.querySelector(".nextBtn");
    // },
  }
};
</script>

<style lang="scss" scoped>
$primary: #0033ea;
$secondary: #000000;
$tertiary: #a2b0e3;
$whiteText: #ffffff;

@font-face {
  font-family: "Gotham-bold";
  src: local("Gotham-bold"),
    url("../assets/fonts/shelta_fonts/Gotham\ Bold.otf") format("truetype");
}
@font-face {
  font-family: "Gotham";
  src: local("Gotham"),
    url("../assets/fonts/shelta_fonts/Gotham\ Book.otf") format("truetype");
}
@font-face {
  font-family: "Gotham-medium";
  src: local("Gotham-medium"),
    url("../assets/fonts/shelta_fonts/Gotham\ Medium.otf") format("truetype");
}

// $gray:  #E5E5E5;
// $gray2: #808080;
// $blue:  #2183DD;
// $green: #009900;
// $white: #FFFFFF;

// File upload section
.has-text-danger {
  color: #dc3545 !important;
  font-size: 10px;
}
.has-text-success {
  color: #28a745 !important;
}
.level {
  font-size: 10px;
  display: flex;
  justify-content: space-between;
}
.remove-file {
  background: $primary;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50px;
  padding-top: 0.219rem;
  color: $whiteText;
}
// File upload section ends

.super {
  flex-direction: column;
  display: flex;
  min-height: 100vh;
  position: relative;
}
.holder {
  flex-grow: 1;
  min-height: 100%;
  background-color: #efefee;
}

// Nav bar begins
.b2d {
  padding-left: 0.5rem;
  position: relative;
  top: 0.2rem;
}
.b2d:hover {
  pointer-events: none;
}
.ms {
  padding-right: 0.5rem;
  position: relative;
  top: 0.2rem;
}
.dashboard-icon {
  background: $primary;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  display: inline-block;
}
.dashboard-icon > img {
  padding-top: 0.5rem;
  width: 60%;
}

.navLinks {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 12px;
  // display: flex;
  align-items: center;
  color: $secondary;
}
.navLinks:first-child {
  padding-top: 1rem;
}
.nav-top {
  background: $whiteText;
  // padding: 1.4rem;
}

.logo-div {
  margin: auto;
  // width: 12rem;
  height: 7rem;
  height: 4rem;
  position: relative;
  bottom: 1rem;
}
.logo-blueDiv-main > img {
  width: 14.3016105417vw;
}
.shelta-img-div > img {
  width: 6.7115666179vw;
}
.shelta-img-div {
  position: absolute;
  top: 26%;
  left: 26%;
  cursor: pointer;
}

.logo-div > img:first-child {
  position: relative;
  width: 18.301610541727673vw;
  margin: auto;
  top: 0;
  right: 32%;
}
.logo-div > img:nth-child(2) {
  width: 8.711566617862372vw;
  // width: 6.5rem;
  position: absolute;
  bottom: -53%;
  left: 7%;
}
// Nav bar ends

.body-wrap {
  padding-top: 6rem;
}
.container-fluid .progress-bar2 {
  display: flex;
  margin: 40px 0;
}

.container-fluid .progress-bar2 .step {
  position: relative;
  text-align: center;
  width: 100%;
}

.progress-bar2 .step p {
  font-size: 18px;
  font-weight: 500;
  color: $secondary;
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 12px;
  align-items: center;
  margin-bottom: 8px;
  transition: 0.2s;
}
// .progress-bar2 .step p:nth-child(2) {
//   font-size: 18px;
//   font-weight: 500;
//   color: $secondary;
//   font-family: Gotham;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 13px;
//   line-height: 12px;
//   align-items: center;
//   margin-bottom: 8px;
//   transition: 0.2s;
// }

.progress-bar2 .step p.active {
  color: $primary;
}

// .progress-bar2 .step p:nth-child(2).active {
//   color: $primary;
// }

.progress-bar2 .step:last-child .bullet::before,
.progress-bar2 .step:last-child .bullet::after {
  display: none;
}

.progress-bar2 .step .bullet::before,
.progress-bar2 .step .bullet::after {
  position: absolute;
  content: "";
  height: 3px;
  // width: 22.7vw;
  width: 19.5vw;
  background: #d4d4d4;
  bottom: 11px;
  left: 20.2px;
}

.progress-bar2 .step .bullet.active::after {
  background: $primary;
  transform: scaleX(0);
  transform-origin: left;
  animation: animate 0.3s linear forwards;
}

@keyframes animate {
  100% {
    transform: scaleX(1);
  }
}

.progress-bar2 .step .bullet.active {
  border-color: $primary;
  background: $primary;
}

.progress-bar2 .step .bullet {
  position: relative;
  height: 25px;
  width: 25px;
  border: 2px solid #c4c4c4;
  display: inline-block;
  border-radius: 50%;
  transition: 0.2s;
}

.progress-bar2 .step .bullet span {
  font-weight: 500;
  font-size: 17px;
  line-height: 23px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.progress-bar2 .step .bullet.active span {
  display: none;
}

.progress-bar2 .step .check {
  display: none;
  position: absolute;
  left: 50%;
  top: 63%;
  font-size: 15px;
  transform: translate(-50%, -50%);
}
.progress-bar2 .step .check.active {
  display: block;
  color: $whiteText;
}

.container-fluid .form-outter {
  width: 100%;
  overflow: hidden;
}
.form-outter form {
  display: flex;
  width: 400%;
}
.form-outter form .page {
  width: 25%;
  transition: margin-left 0.3s ease-in-out;
}
// Wizard section ends

// Details form part begins
.title-wrap {
  padding: 2rem 0rem 1rem 0rem;
}

.required_asterix {
  color: #ea0000;
  padding-left: 5px;
  padding-top: 9px;
  font-size: 24px;
}
.rls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 51, 234, 0.2);
  margin: auto;
  overflow-y: auto;
  height: 66px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.details-header {
  margin: auto;
  background: $primary;
  height: 3rem;
  border-radius: 20px 20px 0px 0px;
}

.details-header-text > p {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: $whiteText;
  margin-bottom: 0;
  padding-top: 0.7rem;
  padding-left: 1rem;
}

.details-first-section {
  background: #ffffff;
  margin: 1rem auto;
}

.form-wrap {
  padding: 1.5rem 1rem 1rem 1rem;
}
.form-select {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid #c4c4c4 !important;
  color: $secondary !important;
  font-family: Gotham !important;
  font-style: italic !important;
  font-weight: 300 !important;
  font-size: 14px !important;
  line-height: 13px !important;
  box-shadow: none !important;
  // align-items: center;
}

.select-label {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: $secondary;
}

.propertyBtn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 4rem;
}
.propertyBtn > button {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 14px;
  align-items: center;
  width: 134px;
  height: 45px;
  color: $whiteText;
  background-color: #2fc643;
  // padding-top: 1rem;
  border-color: none;
}

.newfacility_div {
  display: flex;
}
.new_feature {
  box-shadow: none;
  outline: 0;
  font-family: Gotham;
  color: $secondary !important;
  font-weight: normal;
  font-size: 12px;
}

.newfacility_btn {
  color: #ffffff;
  background: $primary;
  font-size: 12px;
  font-family: Gotham;
  font-weight: normal;
  font-style: normal;
  margin-left: 0.5rem;
  display: flex;
  height: 31px;
}
// Details second section begins
.details-second-section {
  background: #ffffff;
  margin: 1rem auto;
  border-radius: 0px 0px 20px 20px;
}
// Details second section ends

// Details button
.details-btn-wrap {
  margin: 1rem auto;
}
.detail-btn-holder {
  display: flex;
  justify-content: space-between;
}
.detail-btn-holder > button:first-child {
  background: #c4c4c4;
  border-radius: 5px;
  width: 134px;
  height: 45px;
}
.detail-btn-holder > button:nth-child(2) {
  width: 134px;
  height: 45px;
  background: #2fc643;
  border-radius: 5px;
  color: $whiteText;
}

// Facility check
.feature-text {
  display: flex;
  padding-bottom: 1rem;
  margin-left: 1rem;
  cursor: pointer;
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 17px;
  align-items: center;
  color: $secondary;
  width: fit-content;
}

.fa-arrow-down {
  color: $secondary;
  margin-left: 10px;
}

.arrow_up {
  transform: rotate(180deg);
}

.bounce {
  animation: bounce 2s infinite;
}
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}
.bounceUp {
  animation: bounce 2s infinite;
}
@keyframes bounceUp {
  100%,
  80%,
  50%,
  20%,
  0% {
    transform: translateY(0);
  }
  60% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(-10px);
  }
}
.check-box-facility {
  display: flex;
  flex-wrap: wrap;
}
.facility-check {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 23px;
  // display: flex;
  align-items: center;
  color: $secondary;
}
.facility-checkbox {
  padding-top: 4rem;
  padding-bottom: 2rem;
}
.checkbox-wrap {
  padding-left: 1rem;
  text-align: start;
}
// Facility check

// File upload section
.upload-header {
  padding-top: 2rem;
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 15px;
  align-items: flex-end;
  color: $secondary;
}
.upload-file-holder {
  margin: 3rem auto;
  margin-bottom: 1.5rem;
  width: 285px;
  height: 202px;
  background: #ffffff;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
}
.file-holder {
  padding-top: 2rem;
}
.file-holder > img:first-child {
  cursor: pointer;
}
.file-holder > p:nth-child(3) {
  padding-top: 1rem;
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 11px;
  align-items: center;
  color: rgba(0, 0, 0, 0.9);
}
.browse {
  color: $primary;
  text-decoration: underline;
}

.file-type {
  font-family: Gotham;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 11px;
  align-items: center;
  color: #b93623;
}
.tm {
  text-align: start;
  padding: 1rem 3rem 0 3rem;
}
// File upload section

// We got you covered
.good-finished {
  padding: 7rem 0 2rem 0;
}
.good-finished > img {
  width: 5rem;
}
.got-covered-text {
  font-family: Gotham;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 50px;
  text-align: center;
  color: $primary;
  padding-bottom: 7rem;
}
.start-btn-holder > button {
  width: 134px;
  height: 45px;
  background: $primary;
  // line-height: 46px;
  border-radius: 5px;
  color: $whiteText !important;
}
// we got you covered ends

input[type="radio"]:checked:after {
  background-color: #6886f0 !important;
  // border: 2px solid white;
}

.uploading_text {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.file_uploaded_successfully {
  padding-top: 3.5rem !important;
  p {
    color: #28a745 !important;
  }
}
.file-holder > h6:nth-child(3) {
  font-family: Gotham;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  align-items: center;
  text-align: center;
  margin-top: 25px;
  color: #ff9c2a;
}

@media screen and (max-width: 320px) and (max-height: 640px) and (-webkit-device-pixel-ratio: 2) {
  .logo-blueDiv-main > img {
    width: 33.301611vw;
  }
  .shelta-img-div > img {
    width: 15.711567vw;
  }
}
@media screen and (max-width: 360px) and (max-height: 640px) and (-webkit-device-pixel-ratio: 2) {
  .logo-blueDiv-main > img {
    width: 33.301611vw;
  }
  .shelta-img-div > img {
    width: 15.711567vw;
  }
}
@media only screen and (max-width: 599px) {
  .logo-blueDiv-main > img {
    width: 33.301611vw;
  }
  .shelta-img-div > img {
    width: 15.711567vw;
  }
  .nav-top {
    height: 3rem;
  }
  .navLinks {
    padding-bottom: 2rem;
  }
  .logo-div {
    right: 0.5rem;
  }
  .progress-bar2 .step .bullet::before,
  .progress-bar2 .step .bullet::after {
    left: 22px;
    width: 16.7vw;
  }
  .detail-btn-holder > button:first-child {
    width: 86px;
    height: 36px;
  }
  .file-type {
    line-height: 15px;
  }
  .upload-file-holder {
    width: 240px;
  }
  .file-holder {
    padding-top: 2rem;
  }
  .detail-btn-holder > button:nth-child(2) {
    width: 86px;
    height: 36px;
  }
  .newfacility_div {
    display: block;
  }
  .newfacility_btn {
    display: inline-block;
    margin-top: 15px;
  }
  .propertyBtn {
    justify-content: center !important;
  }
  .propertyBtn > button {
    width: 102px;
    height: 36px;
  }
  .tm {
    padding: 3rem 0 0 0;
  }
  .details-header-text > p {
    font-size: 15px;
    display: block;
    padding-left: 0;
  }
  .propertyBtn {
    margin-bottom: 4rem;
  }
  .feature-text {
    display: block;
    text-align: left;
    font-size: 17px;
  }
  .check-box-facility {
    display: inline;
  }
  // .checkbox-wrap {

  // }
  .property-holder {
    padding: 0;
  }
  .details-first-section {
    padding: 0;
  }
  .form-wrap {
    padding: 1.5rem 0.5rem 1rem 0.5rem;
  }
  .facility-checkbox {
    padding-top: 3rem;
  }
}

.unit-count-holder {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  // margin-bottom: 15px;
  h3 {
    font-family: Lato;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #2B3352;
  }
}
.unit-text-button {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  h6 {
    font-family: Lato;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    color: #2B3352;
  }
  button {
    font-family: Lato;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    color: #0033ea;
    border-bottom: 1px solid #0033ea;
    border-radius: 0;
    box-shadow: none;
    outline: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
.addNewUnit {
  h6 {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #555C74;
    margin-top: 10px;
  }
}
</style>
